import { TNotificationStatus } from "./interface";

export const notificationImportantStatuses: TNotificationStatus[] = [
	'important',
	'important_light'
];

export const isImportantNotificationStatus = (
	status?: TNotificationStatus
): boolean => {
	return !!status
		&& notificationImportantStatuses.includes(
			status
		);
};